<div
	class="rich-contract-content"
	[class.rich-contract-content--editable]="editable"
>
	<ng-container *ngFor="let block of blocks; trackBy: trackBlock">
		<div class="rich-contract-content__text" *ngIf="block.type === 'rich-text'">
			<quill-editor
				*ngIf="editable"
				format="html"
				[modules]="quillModules"
				[ngModel]="block.html"
				(ngModelChange)="updateRichText(block.id, $event)"
			></quill-editor>
			<div class="ql-editor" *ngIf="!editable" [innerHTML]="block.html"></div>
		</div>

		<div class="rich-contract-table" *ngIf="block.type === 'table'">
			<div class="rich-contract-table__scroll">
				<table>
					<thead>
						<tr>
							<th
								*ngFor="
									let cell of block.header;
									let cellIndex = index;
									trackBy: trackCell
								"
								[attr.data-label]="'Coluna ' + (cellIndex + 1)"
							>
								<input
									*ngIf="editable"
									[attr.aria-label]="'Nome da coluna ' + (cellIndex + 1)"
									[value]="cell"
									(input)="updateTableCell(block.id, 0, cellIndex, $event)"
								/>
								<span *ngIf="!editable" [innerHTML]="getCellHtml(cell)"></span>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr
							*ngFor="
								let row of block.rows;
								let rowIndex = index;
								trackBy: trackCell
							"
						>
							<td
								*ngFor="
									let cell of row;
									let cellIndex = index;
									trackBy: trackCell
								"
								[attr.data-label]="
									block.header[cellIndex] || 'Coluna ' + (cellIndex + 1)
								"
							>
								<input
									*ngIf="editable"
									[attr.aria-label]="
										block.header[cellIndex] || 'Coluna ' + (cellIndex + 1)
									"
									[value]="cell"
									(input)="
										updateTableCell(block.id, rowIndex + 1, cellIndex, $event)
									"
								/>
								<span *ngIf="!editable" [innerHTML]="getCellHtml(cell)"></span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<p class="rich-contract-table__hint" *ngIf="editable">
				Edite os campos diretamente na tabela.
			</p>
		</div>
	</ng-container>
</div>
